//* Libraries imports
import { useMutation } from "@tanstack/react-query";

//* Service imports
import { paymentAsaasService } from "@/services/asaas/paymentService";

//* Types imports
import type { ApiError } from "@/types/api";
import type {
  CreatePaymentAsaasDTO,
  PaymentResponseAsaasDTO,
} from "@/schemas/asaas/payment";

import { QUERY_KEYS, queryInvalidator } from "@/utils/query-client";

export function useCreatePayment() {
  return useMutation({
    mutationFn: async (data: CreatePaymentAsaasDTO) => {
      const response = await paymentAsaasService.create(data);

      if ("code" in response && "message" in response) {
        const apiError = response as ApiError;
        const error = new Error(apiError.message);
        // @ts-ignore
        error.code = apiError.code;
        throw error;
      }

      if ("data" in response) {
        return response.data as PaymentResponseAsaasDTO;
      }

      throw new Error("Ocorreu um erro ao criar o pagamento no Asaas");
    },
    onSuccess: async (_, variables) => {
      await queryInvalidator([
        [QUERY_KEYS.SALES.ALL],
        [QUERY_KEYS.SALES.SINGLE, variables.saleId],
      ]);
    },
  });
};
